// @flow
export default (unixTimestamp: number): string => {
  // Multiply by 1000 to convert seconds to miliseconds
  return new Date(unixTimestamp * 1000).toISOString()
}
